import React from 'react';
import PropTypes from 'prop-types';
import Media from './Media';
import StyledGalleryDragOverlay from './GalleryDragOverlay.styled';
function GalleryDragOverlay(_ref) {
  var src = _ref.src;
  return /*#__PURE__*/React.createElement(StyledGalleryDragOverlay, null, /*#__PURE__*/React.createElement(Media, {
    src: src
  }));
}
GalleryDragOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  src: PropTypes.string.isRequired
} : {};
export default GalleryDragOverlay;